import React from "react";
// ANT DESIGN COMPONENTS
import { Alert } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// STYLES
import unauthorizedImage from "../../assets/error/cop2.png";

function UnauthorizedPage() {
  const [t] = useTranslation("global");

  return (
    <div>
      <div className="generalStyles__flexCenter">
        <img src={unauthorizedImage} alt="" />
      </div>
      <br />
      <br />
      <div className="generalStyles__flexCenter ">
        <Alert
          message={t("general.unauthorizedTitle")}
          description={t("general.unauthorizedDescription")}
          type="error"
          showIcon
        />
      </div>
    </div>
  );
}

export default UnauthorizedPage;
